export default "__VITE_ASSET__e3NZq_79__"